var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinFill = function SvgLinkedinFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.946 5.7a1.8 1.8 0 1 1-3.6-.002 1.8 1.8 0 0 1 3.6.001M8 8.83H4.4V20.1H8zm5.688 0h-3.582V20.1h3.546v-5.913c0-3.294 4.293-3.6 4.293 0V20.1H21.5v-7.137c0-5.553-6.354-5.346-7.848-2.619z"
  })));
};
export default SvgLinkedinFill;